<template>
	<v-row align="center" justify="center">
		<v-col cols="12" sm="8" md="6" lg="3">
			<v-card flat class="mx-auto grey lighten-5" max-width="344" >
				<v-img :src="require('../../assets/icon-analytics-black.svg')" style="opacity:.15; margin-bottom:-30px"></v-img>
				<v-card-title style="justify-content:center; font-size:1.6rem; margin-bottom:10px">Здесь пока пусто</v-card-title>
				<v-card-subtitle style="text-align:center">Добавьте данные для анализа во вкладке «{{uploadDataTabName}}» или посмотрите пример с использованием тестовых данных.</v-card-subtitle>
				<v-card-actions>
					<v-btn block color="blue lighten-1" :loading="pending" dark @click="loadDummyData">Загрузить тестовые данные</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name:"EmptyProject",
	props: { data: { default:null }, uploadDataTabName: { default:"Управление данными" } },
	data: () => ({
		pending:false
	}),
	created(){
		this.$eventBus.$on('loaded_dummy_data', () => this.pending = false)
	},
	methods: {
		loadDummyData(){
			this.$eventBus.$emit('load_dummy_data')
			this.pending = true
		}
	}
}
</script>

